import React from 'react'
import NavItem from './item';
import styles from './index.module.scss?v=20220629'

function Nav() {
    return (
        <nav className={styles.nav}>
            <NavItem></NavItem>
        </nav>
    )
}

export default Nav;